import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
export const checkUniquenessValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const keysArray = control as FormArray;
  const formKeys = keysArray.controls.map(
    ctrl => ctrl.get('properties.key')?.value
  );
  const duplicates = formKeys.filter(
    (key, index, self) => self.indexOf(key) !== index
  );

  return duplicates.length > 0 ? { nonUniqueKeys: duplicates } : null;
};
